import React, {Component} from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_openModal, _removeModal} from '../../../store';
import PropTypes from 'prop-types';
import axiosInstance from '../../../utils/axios';
import history from '../../../../history';
import debug from 'debug';
import Button from '../../Button';
import DescriptiveText from '../../DescriptiveText';
import {TextInput, Row} from '../../../index';

const log = debug('circleblack:monitoring');

class TwoFactorAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: props.content,
      username: '',
      password: '',
      title: 'Kibana Credentials',
    };
  }

  updateFormData = (name, val) => {
    this.setState({[name]: val});
  };

  submitCredentials = (credentials) => {
    axiosInstance.put('/auth/kibana', credentials)
      .then(() => {
        this.props.dispatchRemoveModal(this.props.content);
        if (this.props.content.action) {
          this.props.content.action();
        } else {
          history.push('/monitoring');
        }
      })
      .catch(err => {
        log('Submission Error', err);
        this.props.dispatchOpenModal({
          type: 'MessageModal',
          title: 'Submission Error',
          body: err.response && err.response.data && err.response.data.error && err.response.data.error.msg,
        });
      });
  };

  render() {
    const {username, password, content, title} = this.state;
    const {dispatchRemoveModal} = this.props;
    return (
      <BaseModal onClose={() => dispatchRemoveModal(content)} title={title}>
        <div>
          <DescriptiveText>Input Kibana credentials to link a Kibana user.</DescriptiveText>
        </div>
        <form onSubmit={event => {
          event.preventDefault();
          this.submitCredentials({username, password});
        }}>
          <Row>
            <TextInput name="username"
                       type="text"
                       placeholder={'Enter Username...'}
                       dataPoint={{name: 'username', value: username}}
                       onChange={this.updateFormData}
                       required>
            </TextInput>
            <TextInput name="password"
                       type="password"
                       dataPoint={{name: 'password', value: password}}
                       placeholder={'Enter Password...'}
                       onChange={this.updateFormData}
                       required>
            </TextInput>
            <div>
              <Button
              importance={'secondary'}
              size={'lg'}
              label={'Cancel'}
              disabled={false}
              action={() => dispatchRemoveModal(content)}>
              </Button>
              <Button importance={'secondary'} size={'lg'} label={'Submit'} action={'SUBMIT'}/>
            </div>
          </Row>
        </form>
      </BaseModal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
  dispatchOpenModal: modal => {
    dispatch(_openModal(modal));
  },
});

export default connect(null, mapDispatchToProps)(TwoFactorAuth);

TwoFactorAuth.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    componentName: PropTypes.string.isRequired,
    action: PropTypes.func,
  }),
  dispatchRemoveModal: PropTypes.func.isRequired,
  dispatchOpenModal: PropTypes.func.isRequired,
};
